import clsx from 'clsx';
import { UseFormRegisterReturn } from 'react-hook-form';
import { FieldWrapper, FieldWrapperPassThroughProps } from './FieldWrapper';
import info from '@/assets/info.svg';

type TextAreaFieldProps = FieldWrapperPassThroughProps & {
  className?: string;
  wrapperClass?: string;
  placeholder?: string;
  disabled?: boolean;
  registration: Partial<UseFormRegisterReturn>;
  rows?: number;
  tooltip?: string;
};
export const TextAreaField = (props: TextAreaFieldProps) => {
  const {
    label,
    wrapperClass,
    className,
    placeholder,
    registration,
    rows = 10,
    error,
    disabled,
    tooltip,
  } = props;
  return (
    <FieldWrapper className={wrapperClass ?? ''} label={label} error={error}>
      <div className="form-field area">
        <label className="skill-info d-flex align-items-center relative justify-between">
          <span>{label}</span>
          {tooltip && (
            <div className="label-tooltip">
              <img src={info} className="info-icon" />
              <span className="tooltip-text">{tooltip}</span>
            </div>
          )}
        </label>
        {/* <label>{label}</label> */}
        <textarea
          disabled={disabled}
          placeholder={placeholder ?? label}
          rows={rows}
          className={clsx('form-control h-100', className)}
          {...registration}
        />
      </div>
    </FieldWrapper>
  );
};
